import React from 'react';
import './css/Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="logo">AzureArch</div>
            <p>Expert Azure consulting and custom development solutions for modern enterprises.</p>
          </div>
          
          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><a href="#services">Azure Migration</a></li>
              <li><a href="#services">Architecture Design</a></li>
              <li><a href="#services">Custom Development</a></li>
              <li><a href="#services">DevOps</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              <li><a href="#projects">Portfolio</a></li>
              <li><a href="#">About Us</a></li>
              <li><a href="#">Careers</a></li>
              <li><a href="#">Blog</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Connect</h4>
            <ul>
              <li><a href="#">LinkedIn</a></li>
              <li><a href="#">GitHub</a></li>
              <li><a href="#">Twitter</a></li>
              <li><a href="mailto:contact@azurearch.com">Email</a></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} AzureArch. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
